export const getQueryParams = (search) => {
  const queryParams = new URLSearchParams(search);
  const paramsObject = {};
  queryParams.forEach((value, key) => {
    let _val = value;
    if (key.endsWith("_ts")) {
      _val = Number(_val);
    }
    paramsObject[key] = _val;
  });
  return paramsObject;
};

export function debounce(func, delay) {
  let timer; // Holds the reference to the timeout

  return function (...args) {
    const context = this;

    // Clear the existing timer
    clearTimeout(timer);

    // Set a new timer
    timer = setTimeout(() => {
      func.apply(context, args);
    }, delay);
  };
}
